import { FilterOperatorType } from './filter-operator-type';
import { ODataFilterValues } from './odata-filter';
import { SearchValueType } from './search-value-type';
export class FilterOperator {
  constructor(
    public displayName: string,
    public displayOperator: FilterOperatorType,
    public actualOperator: FilterOperatorType,
    public isSearchValueNeeded: boolean,
    public behaveAs?: SearchValueType,
    public defaultSearchValues?: any[],
    public targetField?: string
  ) {}
}
export type operator = {
  valueTypeSupport: SearchValueType; //not needed?
  operators: FilterOperator[];
};
export const OPERATORS: Record<SearchValueType, operator> = {
  String: {
    valueTypeSupport: SearchValueType.String,
    operators: [
      new FilterOperator('is', FilterOperatorType.eq, FilterOperatorType.eq, true),
      new FilterOperator('is not', FilterOperatorType.ne, FilterOperatorType.ne, true),
      new FilterOperator(
        'contains',
        FilterOperatorType.contains,
        FilterOperatorType.contains,
        true
      ),
      new FilterOperator(
        "doesn't contain",
        FilterOperatorType.notContains,
        FilterOperatorType.contains,
        true
      ),
      new FilterOperator(
        'starts with',
        FilterOperatorType.startswith,
        FilterOperatorType.startswith,
        true
      ),
      new FilterOperator(
        'ends with',
        FilterOperatorType.endswith,
        FilterOperatorType.endswith,
        true
      ),
      new FilterOperator('is empty', FilterOperatorType.isEmpty, FilterOperatorType.eq, false),
      new FilterOperator(
        'is not empty',
        FilterOperatorType.isNotEmpty,
        FilterOperatorType.ne,
        false
      )
    ]
  },
  Email: {
    valueTypeSupport: SearchValueType.Email,
    operators: [
      new FilterOperator('is', FilterOperatorType.eq, FilterOperatorType.eq, true),
      new FilterOperator('is not', FilterOperatorType.ne, FilterOperatorType.ne, true),
      new FilterOperator('is one of', FilterOperatorType.in, FilterOperatorType.in, true),
      new FilterOperator(
        'contains',
        FilterOperatorType.contains,
        FilterOperatorType.contains,
        true
      ),
      new FilterOperator(
        "doesn't contain",
        FilterOperatorType.notContains,
        FilterOperatorType.contains,
        true
      ),
      new FilterOperator(
        'starts with',
        FilterOperatorType.startswith,
        FilterOperatorType.startswith,
        true
      ),
      new FilterOperator(
        'ends with',
        FilterOperatorType.endswith,
        FilterOperatorType.endswith,
        true
      ),
      new FilterOperator('is empty', FilterOperatorType.isEmpty, FilterOperatorType.eq, false),
      new FilterOperator(
        'is not empty',
        FilterOperatorType.isNotEmpty,
        FilterOperatorType.ne,
        false
      )
    ]
  },
  Number: {
    valueTypeSupport: SearchValueType.Number,
    operators: [
      new FilterOperator('equals', FilterOperatorType.eq, FilterOperatorType.eq, true),
      new FilterOperator("doesn't equal", FilterOperatorType.ne, FilterOperatorType.ne, true),
      new FilterOperator('greater than', FilterOperatorType.gt, FilterOperatorType.gt, true),
      new FilterOperator(
        'greater than or equals',
        FilterOperatorType.ge,
        FilterOperatorType.ge,
        true
      ),
      new FilterOperator('less than', FilterOperatorType.lt, FilterOperatorType.lt, true),
      new FilterOperator('less than or equals', FilterOperatorType.le, FilterOperatorType.le, true),
      new FilterOperator('is empty', FilterOperatorType.isEmpty, FilterOperatorType.eq, false),
      new FilterOperator(
        'is not empty',
        FilterOperatorType.isNotEmpty,
        FilterOperatorType.ne,
        false
      )
    ]
  },
  Date: {
    valueTypeSupport: SearchValueType.Date,
    operators: [
      new FilterOperator('is', FilterOperatorType.eq, FilterOperatorType.eq, true),
      new FilterOperator('before', FilterOperatorType.lt, FilterOperatorType.lt, true),
      new FilterOperator('after', FilterOperatorType.gt, FilterOperatorType.gt, true),
      new FilterOperator('today', FilterOperatorType.today, FilterOperatorType.eq, false),
      new FilterOperator('yesterday', FilterOperatorType.yesterday, FilterOperatorType.eq, false),
      new FilterOperator(
        'on or before today',
        FilterOperatorType.onOrBeforeToday,
        FilterOperatorType.le,
        false
      ),
      new FilterOperator(
        'on or after today',
        FilterOperatorType.onOrAfterToday,
        FilterOperatorType.ge,
        false
      ),
      new FilterOperator(
        'this week',
        FilterOperatorType.thisWeek,
        FilterOperatorType.thisWeek,
        false
      ),
      new FilterOperator(
        'this month',
        FilterOperatorType.thisMonth,
        FilterOperatorType.thisMonth,
        false
      ),
      new FilterOperator('this year', FilterOperatorType.thisYear, FilterOperatorType.eq, false),
      new FilterOperator(
        'last week',
        FilterOperatorType.lastWeek,
        FilterOperatorType.lastWeek,
        false
      ),
      new FilterOperator(
        'last month',
        FilterOperatorType.lastMonth,
        FilterOperatorType.lastMonth,
        false
      ),
      new FilterOperator('last year', FilterOperatorType.lastYear, FilterOperatorType.eq, false),
      new FilterOperator('is empty', FilterOperatorType.isEmpty, FilterOperatorType.eq, false),
      new FilterOperator(
        'is not empty',
        FilterOperatorType.isNotEmpty,
        FilterOperatorType.ne,
        false
      )
    ]
  },
  DateRange: {
    valueTypeSupport: SearchValueType.DateRange,
    operators: [
      new FilterOperator(
        'is currently active',
        FilterOperatorType.isCurrentlyActive,
        FilterOperatorType.isCurrentlyActive,
        false
      ),
      new FilterOperator(
        'is not currently active',
        FilterOperatorType.isNotCurrentlyActive,
        FilterOperatorType.isNotCurrentlyActive,
        false
      ),
      new FilterOperator(
        'active on',
        FilterOperatorType.activeOn,
        FilterOperatorType.activeOn,
        true
      ),
      new FilterOperator(
        'starts before',
        FilterOperatorType.startsBefore,
        FilterOperatorType.lt,
        true
      ),
      new FilterOperator(
        'starts after',
        FilterOperatorType.startsAfter,
        FilterOperatorType.gt,
        true
      ),
      new FilterOperator('ends before', FilterOperatorType.endsBefore, FilterOperatorType.lt, true),
      new FilterOperator('ends  after', FilterOperatorType.endsAfter, FilterOperatorType.gt, true),
      new FilterOperator('is empty', FilterOperatorType.isEmpty, FilterOperatorType.eq, false),
      new FilterOperator(
        'is not empty',
        FilterOperatorType.isNotEmpty,
        FilterOperatorType.ne,
        false
      )
    ]
  },
  Boolean: {
    valueTypeSupport: SearchValueType.Boolean,
    operators: [
      new FilterOperator('is', FilterOperatorType.eq, FilterOperatorType.eq, true),
      new FilterOperator('is not', FilterOperatorType.ne, FilterOperatorType.ne, true)
    ]
  },
  List: {
    valueTypeSupport: SearchValueType.List,
    operators: [
      new FilterOperator('is', FilterOperatorType.eq, FilterOperatorType.eq, true),
      new FilterOperator('is not', FilterOperatorType.ne, FilterOperatorType.ne, true)
    ]
  },
  MultiValue: {
    valueTypeSupport: SearchValueType.MultiValue,
    operators: [
      new FilterOperator('is any of', FilterOperatorType.in, FilterOperatorType.in, true),
      new FilterOperator('is not any of', FilterOperatorType.notIn, FilterOperatorType.in, true),
      new FilterOperator('is empty', FilterOperatorType.isEmpty, FilterOperatorType.eq, false),
      new FilterOperator(
        'is not empty',
        FilterOperatorType.isNotEmpty,
        FilterOperatorType.ne,
        false
      )
    ]
  },
  Skill: {
    valueTypeSupport: SearchValueType.Skill,
    operators: [
      new FilterOperator('is any of', FilterOperatorType.in, FilterOperatorType.in, true),
      new FilterOperator('is not any of', FilterOperatorType.notIn, FilterOperatorType.in, true),
      new FilterOperator(
        'contains',
        FilterOperatorType.contains,
        FilterOperatorType.contains,
        true
      ),
      new FilterOperator('is empty', FilterOperatorType.isEmpty, FilterOperatorType.eq, false),
      new FilterOperator(
        'is not empty',
        FilterOperatorType.isNotEmpty,
        FilterOperatorType.ne,
        false
      )
    ]
  },
  WorkspaceMultiValue: {
    valueTypeSupport: SearchValueType.WorkspaceMultiValue,
    operators: [
      new FilterOperator('is any of', FilterOperatorType.in, FilterOperatorType.in, true),
      new FilterOperator('is not any of', FilterOperatorType.notIn, FilterOperatorType.in, true),
      new FilterOperator('not assigned', FilterOperatorType.isEmpty, FilterOperatorType.eq, false),
      new FilterOperator('assigned', FilterOperatorType.isNotEmpty, FilterOperatorType.ne, false)
    ]
  },
  EvaluationAggregateMultiValue: {
    valueTypeSupport: SearchValueType.EvaluationAggregateMultiValue,
    operators: [
      new FilterOperator('has any of', FilterOperatorType.in, FilterOperatorType.in, true),
      new FilterOperator(
        'does not have any of',
        FilterOperatorType.notIn,
        FilterOperatorType.in,
        true
      )
    ]
  },
  EvaluationAggregateString: {
    valueTypeSupport: SearchValueType.EvaluationAggregateString,
    operators: [
      new FilterOperator(
        'contains',
        FilterOperatorType.contains,
        FilterOperatorType.contains,
        true
      ),
      new FilterOperator(
        "doesn't contain",
        FilterOperatorType.notContains,
        FilterOperatorType.contains,
        true
      ),
      new FilterOperator('is empty', FilterOperatorType.isEmpty, FilterOperatorType.eq, false),
      new FilterOperator(
        'is not empty',
        FilterOperatorType.isNotEmpty,
        FilterOperatorType.ne,
        false
      )
    ]
  },
  Guid: {
    valueTypeSupport: SearchValueType.Guid,
    operators: [
      new FilterOperator('is', FilterOperatorType.eq, FilterOperatorType.eq, true),
      new FilterOperator('is not', FilterOperatorType.ne, FilterOperatorType.ne, true)
    ]
  },
  EmptyOperator: {
    valueTypeSupport: SearchValueType.EmptyOperator,
    operators: [
      new FilterOperator('is empty', FilterOperatorType.isEmpty, FilterOperatorType.eq, false),
      new FilterOperator(
        'is not empty',
        FilterOperatorType.isNotEmpty,
        FilterOperatorType.ne,
        false
      )
    ]
  },
  Payment: {
    valueTypeSupport: SearchValueType.Payment,
    operators: [
      new FilterOperator(
        'is',
        FilterOperatorType.eq,
        FilterOperatorType.eq,
        true,
        SearchValueType.List,
        ['Incomplete', 'Complete'],
        'status'
      ),
      new FilterOperator(
        'is not',
        FilterOperatorType.ne,
        FilterOperatorType.ne,
        true,
        SearchValueType.List,
        ['Incomplete', 'Complete'],
        'status'
      ),
      new FilterOperator(
        'is payment type',
        FilterOperatorType.in,
        FilterOperatorType.in,
        true,
        SearchValueType.MultiValue,
        [
          new ODataFilterValues('Card', 'Card'),
          new ODataFilterValues('ACH', 'ACH'),
          new ODataFilterValues('Check', 'Check'),
          new ODataFilterValues('Waived', 'Waived')
        ],
        'paymentType'
      ),
      new FilterOperator(
        'has order number',
        FilterOperatorType.eq,
        FilterOperatorType.eq,
        true,
        SearchValueType.String,
        null,
        'orderNumber'
      )
    ]
  },
  PhoneNumber: {
    valueTypeSupport: SearchValueType.PhoneNumber,
    operators: [
      new FilterOperator(
        'contains',
        FilterOperatorType.contains,
        FilterOperatorType.contains,
        true
      ),
      new FilterOperator('is empty', FilterOperatorType.isEmpty, FilterOperatorType.eq, false),
      new FilterOperator(
        'is not empty',
        FilterOperatorType.isNotEmpty,
        FilterOperatorType.ne,
        false
      )
    ]
  }
};
